module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    ref: "menu",
    staticClass: "sidebar-menu"
  }, [_c('ul', {
    staticClass: "menu-items"
  }, _vm._l((_vm.navTree), function(item, index) {
    return _c('NavItem', {
      key: index,
      attrs: {
        "item": item
      }
    })
  }))])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-1e7c77eb","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./~/vue-loader/lib/selector.js?type=template&index=0!./src/containers/Home/Sidebar/NavList.vue
// module id = 1712
// module chunks = 1